// Session-scoped statement upload log — claims only what this tab proved
// (docs/design/console-personas.md §4.4–§4.5). Never claims history.

import type { CompanySlug } from "./types.js";

export interface SessionUpload {
  /** A company slug: an internal key, never a word a person reads. */
  company: CompanySlug;
  period: string;
  account: string;
  uploadedAt: string;
  contentSha256Hex: string;
}

const uploads: SessionUpload[] = [];

export function recordSessionUpload(entry: SessionUpload): void {
  uploads.push(entry);
}

export function listSessionUploads(): readonly SessionUpload[] {
  return uploads;
}

export function sessionUploadCount(): number {
  return uploads.length;
}

/** Test-only reset. */
export function clearSessionUploads(): void {
  uploads.length = 0;
}
